// src/modules/app-views/account/components/AccessProfileSelect.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Select, Tooltip } from 'antd';
import { KeyOutlined, LockOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import { normalize } from 'utils/helpers';

// *******************************************************************************
// HELPERS (exported for reuse)
// *******************************************************************************
export function getAccessProfileTooltip(value) {
  switch (value) {
    case 'owner':
      return translateX('owner_access');
    case 'guest':
      return translateX('restricted_access');
    case 'keyUser':
      return translateX('total_access');
    default:
      return translateX('custom_access');
  }
}

export function accessProfileOptions() {
  return [
    {
      value: 'owner',
      text: normalize(translateX('partner_owner'), 'lower'),
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <SafetyCertificateOutlined className="font-size-md" />
          {translateX('partner_owner')}
        </div>
      ),
    },
    {
      value: 'keyUser',
      text: normalize(translateX('key_user'), 'lower'),
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <KeyOutlined className="font-size-md" />
          {translateX('key_user')}
        </div>
      ),
    },
    {
      value: 'guest',
      text: normalize(translateX('common_user'), 'lower'),
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <LockOutlined className="font-size-md" />
          {translateX('common_user')}
        </div>
      ),
    },
  ];
}

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const AccessProfileSelect = ({ onChange, value }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const options = accessProfileOptions();

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Tooltip title={getAccessProfileTooltip(value)} placement="top">
      <Select
        style={{ width: '100%' }}
        showSearch
        placeholder={translateX('access_profile')}
        optionFilterProp="label"
        value={value}
        onChange={onChange}
        options={options || []}
      />
    </Tooltip>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default AccessProfileSelect;
